import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { SliceLayoutBoundary, SiteHeaderLayout, ExplorerEntityDetailsLayoutDefaultProps, ExplorerEntityDetailsLayout, ComponentPropsProvider, ExplorerEntityDetailsLayoutProps, BackButtonEntityProvider, SiteHeaderProvider, ExplorerTabs, } from '@shapeable/ui';
import { ExplorerProvider } from '../providers/explorer-provider';
import { Topic } from '@shapeable/copper-connect-types';
import { ValueChainNavigator } from '../elements/value-chain-navigator';
import { useValueChainMap } from '../../hooks/use-value-chain-map';
import { ValueChainNavigatorMain } from '../elements/value-chain-navigator-main';
import { TopicTabsLayout } from './topic-tabs-layout';
import { TopicBannerLayout } from './topic-banner-layout';
import { TopicViewLayout } from './topic-view-layout';
const cls = classNames('topic-explorer-layout');

// -------- Types -------->

// -------- Props -------->

export type TopicExplorerLayoutProps = ExplorerEntityDetailsLayoutProps & { 
  entity?: Topic;
};

export const TopicExplorerLayoutDefaultProps: Omit<TopicExplorerLayoutProps, 'entity'> = {
  ...ExplorerEntityDetailsLayoutDefaultProps,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const LayoutStyles = breakpoints({
  base: css`

    .shp--entity-banner {
      h2.shp--entity-value__name {
        font-size: ${theme.FONT_SIZE(32)};
      }
    }
  `,
});

const HeaderStyles = breakpoints({
  base: css`
  `,
});

const NavigatorStyles = breakpoints({
  base: css`
  `,
});


const TabsStyles = breakpoints({
  base: css`
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Header: styled(SiteHeaderLayout)`${HeaderStyles}`,
    Layout: styled(ExplorerEntityDetailsLayout)`${LayoutStyles}`,
    Navigator: styled(ValueChainNavigator)`${NavigatorStyles}`,

      Tabs: styled(ExplorerTabs)`${TabsStyles}`,

};

export const TopicExplorerLayout: Shapeable.FC<TopicExplorerLayoutProps> = (props) => {
  const { className, children, entity } = props;
  const { isShown } = useValueChainMap();

  return (
    <SiteHeaderProvider value={{ 
      variant: 'default',
    }}>
    <ExplorerProvider>
    <My.Container>
      <My.Header/>
      <SliceLayoutBoundary boundary='none' >
      <My.Tabs useStickyStyle />
      <My.Layout 
        entity={entity}
        className={cls.name(className)}
        asideIsRevealed={isShown}
        stickyTopOffset={117}
        useMaxWidth={false}
        split={[4.5, 5.5]}
        
        banner={
          <TopicBannerLayout entity={entity} />
        }

        //main
        tabs={
          <TopicTabsLayout entity={entity} />
        }
        content={
          <TopicViewLayout entity={entity} />
        }

        dataVizMain={
          <ValueChainNavigatorMain /> 
        }

        dataViz={
          <My.Navigator />
        }
        />
        </SliceLayoutBoundary>
    </My.Container>
    </ExplorerProvider>
    </SiteHeaderProvider>
  )
};

TopicExplorerLayout.defaultProps = TopicExplorerLayoutDefaultProps;
TopicExplorerLayout.cls = cls;